/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Shipping_N_Delivery__Answer_3Inputs */

const en_help_center__shipping_n_delivery__answer_3 = /** @type {(inputs: Help_Center__Shipping_N_Delivery__Answer_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact us immediately within 48 hours of delivery with photos of the damage. We'll arrange a replacement or full refund (including your entry price and bids used). All shipments are fully insured. Do not discard the original packaging until you've inspected the item.`)
};

/**
* | output |
* | --- |
* | "Contact us immediately within 48 hours of delivery with photos of the damage. We'll arrange a replacement or full refund (including your entry price and bids..." |
*
* @param {Help_Center__Shipping_N_Delivery__Answer_3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__shipping_n_delivery__answer_3 = /** @type {((inputs?: Help_Center__Shipping_N_Delivery__Answer_3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Shipping_N_Delivery__Answer_3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__shipping_n_delivery__answer_3(inputs)
});